import React, { FunctionComponent } from "react";
import { Button, Stack, Container, Text, useTheme } from "@bookingcom/bui-react";
import styles from "./PostBookingCheckoutFooter.module.css";
import { mcn } from "../../../utils/mergeClassnames";

interface Props {
  errorMessage?: string;
  onClickPrimary: () => void;
  onClickSecondary?: () => void;
  labelPrimary: string;
  labelSecondary?: string;
  isPrimaryEnabled?: boolean;
  isPrimaryLoading?: boolean;
  isSecondaryEnabled?: boolean;
  isSecondaryLoading?: boolean;
  sticky?: boolean;
  showBorder?: boolean;
}

const PostBookingCheckoutFooter: FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const {
    errorMessage,
    onClickPrimary,
    labelPrimary,
    onClickSecondary,
    labelSecondary,
    isPrimaryEnabled = true,
    isPrimaryLoading = false,
    isSecondaryEnabled = true,
    isSecondaryLoading = false,
    sticky = false,
    showBorder = true
  } = props;

  return (
    <div
      className={mcn(styles.wrapper, sticky && styles.wrapperSticky)}
      style={{ borderTop: showBorder ? `solid 1px ${theme.colors.color_border_alt}` : "none" }}
    >
      <Container fullWidth mixin={{ paddingBlockStart: 4, paddingBlockEnd: 4 }}>
        {errorMessage && (
          <div className={styles.errorMessage}>
            <Text variant="body_2">{errorMessage}</Text>
          </div>
        )}
        <Stack>
          <Button
            wide
            size="large"
            variant="primary"
            loading={isPrimaryLoading}
            disabled={!isPrimaryEnabled}
            onClick={onClickPrimary}
            text={labelPrimary}
            loadingAriaLabel=""
          />
          {labelSecondary && onClickSecondary && (
            <Button
              wide
              size="large"
              variant="tertiary"
              loading={isSecondaryLoading}
              disabled={!isSecondaryEnabled}
              onClick={onClickSecondary}
              text={labelSecondary}
              loadingAriaLabel=""
            />
          )}
        </Stack>
      </Container>
    </div>
  );
};
export default PostBookingCheckoutFooter;
